export default __webpack_public_path__ + "static/media/door-unlocking.b50f7b42.svg";